import { setAlert } from './Alert';
import { getToken } from './Login';

// автоматически определяем куда коннектится в зависимости от того, 
// в проде мы или на локальной машине
const server_URL = /localhost/.test(window.location.origin) ? 
                        'http://localhost:8000' :  // сервер на локальной машине
                        'https://tomater.synology.me:8000'; // NAS, опубликованный в интернет


// стандартная функция обработки статуса ответа сервера
function fetchStatusCheck(response){
    switch (response.status) {
        case 200:
            return (response.json());
        case 401:
            // проблема с токеном аутентификации - надо идти снова к странице логина
            return Promise.reject("Error 401: Token is not correct.");
        default:
            return Promise.reject('Server reply: '+ response.status + '; ' + response.statusText);
    }
}

function onError (msg){
    let text = "Server-api/onError: unknown type of error...";
    if (typeof msg == 'object')
    {
        console.log(msg); // TODO.. Remove?
        text = msg.message; // ошибка от fetch?
    }
    else if (typeof msg == 'string'){
      text = msg;
    }
    setAlert(text);
}

export default {
    // получение списка проектов с сервера
    getProjectsList: (func) => {
        setAlert(null);
        return fetch(server_URL + "/projects", {
            method: 'get',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // получение описания проекта с сервера
    getProject: (func, proj_id) => {
        setAlert(null);
        return fetch(server_URL + "/projects/" + proj_id, {
            method: 'get',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // добавить новый проект
    // {
    //    name:        string,  // название нового проекта, до 50 символов. Не может быть пустым
    //    description: string   // описание новго проектаб до 200 символов. Допускается пустое
    // }
    // Возвращает описание проекта
    addProject: (func, name, description) => {
        setAlert(null);
        return fetch(server_URL + "/projects", {
            method: 'post',
            body: JSON.stringify({ name, description }),
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // обновить описание проекта
    // {
    //    name:        string,  // новое название проекта, до 50 символов. Не может быть пустым
    //    description: string   // новое описание проектаб до 200 символов. Допускается пустое
    // }
    // Возвращает описание проекта
    updateProject: (func, id, name, description) => {
        setAlert(null);
        return fetch(server_URL + "/projects/" + id, {
            method: 'put',
            body: JSON.stringify({ name, description }),
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // удалить проект
    deleteProject: (func, id) => {
        setAlert(null);
        return fetch(server_URL + "/projects/" + id, {
            method: 'delete',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },    

    // добавить новый фолдер к проекту
    // На входе JSON в теле
    // {
    //    project: string,  // UUID родительского проекта
    //    name:    string   // название для новой папки
    // }    
    addFolder: (func, project_id, folder_name) => {
        setAlert(null);
        return fetch(server_URL + "/folders", {
            method: 'post',
            body: JSON.stringify({project: project_id, name: folder_name}),
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // удалить пустой фолдер 
    // На входе id
    // На выходе тот же id, если все успешно
    deleteFolder: (func, folder_id) => {
        setAlert(null);
        return fetch(server_URL + "/folders/"+folder_id, {
            method: 'delete',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then( json => func(json.id) )
        .catch(onError);
    },

    // считать папку с файлами
    // На входе id
    // На выходе JSON про папку и все ее файлы
    getFolder: (func, folder_id) => {
        setAlert(null);
        return fetch(server_URL + "/folders/"+folder_id, {
            method: 'get',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // получить список всех пользователей
    // На выходе JSON с массивом
    getUsersList: (func) => {
        setAlert(null);
        return fetch(server_URL + "/users", {
            method: 'get',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // Создать нового пользователя
    // На входе JSON в теле
    // {
    //    name:    string   // имя пользователя (максимум 50 символов)
    //    email:   string   // email (максимум 50 символов)
    //    project: string   // uuid проекта, к которому даем права сразу
    // }
    // возвращает JSON c описанием нового пользователя
    addUser: (func, name, email, project ) => {
        setAlert(null);
        return fetch(server_URL + "/users", {
            method: 'post',
            body: JSON.stringify({name, email, project}),
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },


    // обновление информации о пользователе - пока только доступные проекты
    // позже, возможно, профиль
    // На входе JSON в теле
    // {
    //    project: string               // uuid проекта, к которому даем/забираем права сразу
    //    action:  string (add|delete)  // забрать или добавить прав
    // }
    // не возвращаем ничего
    updateUserProjects: (func, user_id, project, action ) => {
        setAlert(null);
        return fetch(server_URL + "/users/" + user_id, {
            method: 'put',
            body: JSON.stringify({project, action}),
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // обновление информации о пользователе - пока только доступные проекты
    // позже, возможно, профиль
    // На входе JSON в теле
    // {
    //    name: string               // имя, на которое заменяем старое (максимум 50 символов)
    // }
    // не возвращаем ничего
    updateUserName: (func, user_id, name ) => {
        setAlert(null);
        return fetch(server_URL + "/users/" + user_id, {
            method: 'put',
            body: JSON.stringify({name}),
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // получить информацию о текущем пользователе
    getMe: (func) => {
        setAlert(null);
        return fetch(server_URL + "/users/me", {
            method: 'get',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },

    // получить информацию о текущем пользователе по ID
    getUser: (func, user_id) => {
        setAlert(null);
        return fetch(server_URL + "/users/" + user_id, {
            method: 'get',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },    

    // удалить пользователя
    deleteUser: (func, user_id) => {
        setAlert(null);
        return fetch(server_URL + "/users/" + user_id, {
            method: 'delete',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },    

    // получить информацию о текуцей версии приложения сервера
    getVersion: (func) => {
        setAlert(null);
        return fetch(server_URL + "/version",  {
            method: 'get',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },    

    // перезапустить и обновить сервер
    updateServer: (func) => {
        setAlert(null);
        return fetch(server_URL + "/version",  {
            method: 'post',
            headers: { 'content-type': 'application/json', 'Authorization': 'Bearer ' + getToken() }})
        .then(fetchStatusCheck)
        .then(func)
        .catch(onError);
    },    


    // обновить токен доступа
    renewAccessToken: (func, session_key, onErr) => {
        setAlert(null);
        return fetch(server_URL + "/auth/renewAccessToken",  {
            method: 'post',
            body: JSON.stringify({session_key}),
            headers: { 'content-type': 'application/json' },
        })
        .then(fetchStatusCheck)
        .then(func)
        .catch(onErr?onErr:onError);
    },    


    // начать процесс аутентификации через отправку письма
    startEmailAuthentification: (func, email, onErr) => {
        setAlert(null);
        return fetch(server_URL + "/auth/startEmailAuthentification",  {
            method: 'post',
            body: JSON.stringify({email}),
            headers: { 'content-type': 'application/json' },
        })
        .then(fetchStatusCheck)
        .then(func)
        .catch(onErr?onErr:onError);
    },    


    // начать процесс аутентификации через отправку письма
    finishEmailAuthentification: (func, session_key, code, onErr) => {
        setAlert(null);
        return fetch(server_URL + "/auth/finishEmailAuthentification",  {
            method: 'post',
            body: JSON.stringify({session_key, code}),
            headers: { 'content-type': 'application/json' },
        })
        .then(fetchStatusCheck)
        .then(func)
        .catch(onErr?onErr:onError);
    },    

    // разлогировать пользователя
    logout: (func, session_key, onErr) => {
        setAlert(null);
        return fetch(server_URL + "/auth/logout",  {
            method: 'post',
            body: JSON.stringify({session_key}),
            headers: { 'content-type': 'application/json' },
        })
        .then(fetchStatusCheck)
        .then(func)
        .catch(onErr?onErr:onError);
    },        

    // загрузить файл на сервер
    // на входе - 
    //  id родительской папочки
    //  объект file
    //     - коллбек для отслеживания прогресса загрузки
    //     - колбек на окончание загрузки
    //     - колбек на ошибку загрузки
    //
    //  возращает ссылку на риквест (чтобы отменить можно было)
    uploadFile: (folder_id, file, onProgress, onDone, onError) => {
        const req = new XMLHttpRequest();
        req.responseType = 'json';

        req.upload.addEventListener("progress", event => {
            if (event.lengthComputable)
                onProgress(file.name, (event.loaded / event.total) * 100);
        });
        
        req.onload = function () {
            if ( req.resonse === null )
                onError(file.name, "Ошибка загрузки" );
            else
                onDone(file.name, req.response); 
        }

        req.upload.addEventListener("error", event => {
            // пока не удалось найти хоть какие-то признаки,
            // позвояющие идентифицировать ошибку 
            // возможные причины - сервер не отвечает, это не файл, а папка, к файлу нет доступа
            onError(file.name, "Ошибка загрузки" );
        });
    
        const formData = new FormData();
        formData.append("file", file, file.name);
        formData.append("folder", folder_id);
    
        req.open("POST", server_URL + "/files");
        req.setRequestHeader('Authorization', 'Bearer ' + getToken() );
        req.send(formData);

        return req;
    },

    // правльная ссылка на скачивание файла
    fileDownloadURL: (file_id, token) => {
        return (server_URL + '/files/' + file_id + '?token=' + token);
    }
};

